import { Component, OnInit } from '@angular/core';
import { DbEcertificateService } from '../../services/db-ecertificate.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-download-certificate',
  templateUrl: './download-certificate.component.html',
  styleUrls: ['./download-certificate.component.css'],
  providers: [DbEcertificateService]
})
export class DownloadCertificateComponent implements OnInit {
  generatedCertificateId: number = 0;
  generatedCertificate: any = {};
  filePath: string = "";
  constructor(private _router: Router, private route: ActivatedRoute, public ECertificateService: DbEcertificateService, private title: Title)
  {
    this.title.setTitle("Download Certificate");
    this.generatedCertificateId = this.route.snapshot.params.id;
    if (this.generatedCertificateId > 0) {      
      this.ECertificateService.getGenerateCertificateByGeneratedCertificateId(this.generatedCertificateId).then(res => {
        this.generatedCertificate = res;        
        if (this.generatedCertificate != null) {
          this.filePath = "'../../../assets/Files/GeneratedCertificates/" + this.generatedCertificate.certificateFilePath;

          //var re = /(?:\.([^.]+))?$/;
          //var ext = re.exec(this.generatedCertificate.certificateFilePath)[1];         
          //var pom = document.createElement('a');
          //pom.setAttribute('href', "'../../../assets/Files/GeneratedCertificates/" + this.generatedCertificate.certificateFilePath);
          //pom.setAttribute('download', 'Certificate.' + ext);
          //pom.style.display = 'none';
          //document.body.appendChild(pom);
          //pom.click();
          //document.body.removeChild(pom);
        }
      });
    }
  }

  ngOnInit() {
  }

  downloadCertificate() {
    var re = /(?:\.([^.]+))?$/;
    var ext = re.exec(this.generatedCertificate.certificateFilePath)[1];
    var pom = document.createElement('a');
    pom.setAttribute('href', "'../../../assets/Files/GeneratedCertificates/" + this.generatedCertificate.certificateFilePath);
    pom.setAttribute('download', 'Certificate.' + ext);
    pom.style.display = 'none';
    document.body.appendChild(pom);
    pom.click();
    document.body.removeChild(pom);
  }
}
